// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-responsive iframe {\n  height: 90px !important;\n  max-width: 150px !important;\n}", "",{"version":3,"sources":["webpack://src/helpers/YoutubeEmbed/YoutubeEmbed.scss"],"names":[],"mappings":"AAEE;EACE,uBAAA;EACA,2BAAA;AADJ","sourcesContent":[".video-responsive {\r\n\r\n  iframe {\r\n    height: 90px !important;\r\n    max-width: 150px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
